export default __webpack_public_path__ + "5b5469e87b491908d80fb827b8179a83.png";